export const mockGoogleAIReturn = {
  attributionToken: 'aFakeToken31',
  results: [
    { id: 's3aqhts1afeoriqudisyfw43my', metadata: {} },
    {
      id: '5ee279835d20c299509b8491',
      metadata: {},
    },
    {
      id: '4ita004bi3cm3opglxmdbk4v2y',
      metadata: {},
    },
    {
      id: '5ee279835d20c299509b8488',
      metadata: {},
    },
    {
      id: '5ee279835d20c299509b848b',
      metadata: {},
    },
    {
      id: 'ydlieyy3hbbhblsl02brr1bcp2',
      metadata: {},
    },
    {
      id: '321',
      metadata: {},
    },
    {
      id: '6048f8e5dc276200087846f8',
      metadata: {},
    },
    { id: '6581e36ec25dd76bd2e45a4b', metadata: {} },
    { id: '6581e36ec25dd76bd2e45a4a', metadata: {} },
    { id: '6581e36ec25dd76bd2e45a56', metadata: {} },
    { id: '6581e36ec25dd76bd2e45a52', metadata: {} },
    { id: '6581e36ec25dd76bd2e45a5a', metadata: {} },
    { id: '6581e36ec25dd76bd2e45a51', metadata: {} },
    { id: '6581e36ec25dd76bd2e45a4d', metadata: {} },
  ],
};
